import { AdminDashboard } from "@/routes/AdminDashboard";
import { AdminEventDashboard } from "@/routes/AdminEventDashboard";
import { AdminEventEditor } from "@/routes/AdminEventEditor";
import { AdminEventsList } from "@/routes/AdminEventsList";
import { AdminLayout } from "@/routes/AdminLayout";
import { AdminNewEvent } from "@/routes/AdminNewEvent";
import { AdminSettings } from "@/routes/AdminSettings";
import { DonatePage } from "@/routes/DonatePage";
import { EventLayout } from "@/routes/EventLayout";
import { EventModulePage } from "@/routes/EventModulePage";
import { EventOverview } from "@/routes/EventOverview";
import { NotFoundView } from "@/routes/NotFound";
import { PlatformHome } from "@/routes/PlatformHome";
import { PrivacyPage } from "@/routes/Privacy";
import { TermsPage } from "@/routes/Terms";
import { Route, Routes } from "react-router-dom";

export default function App() {
  return (
    <Routes>
      <Route path="/" element={<PlatformHome />} />
      <Route path="/donate" element={<DonatePage />} />
      <Route path="/privacy" element={<PrivacyPage />} />
      <Route path="/terms" element={<TermsPage />} />
      <Route path="/admin" element={<AdminLayout />}>
        <Route index element={<AdminEventsList />} />
        <Route path="dashboard" element={<AdminDashboard />} />
        <Route path="events/new" element={<AdminNewEvent />} />
        <Route path="events/:slug" element={<AdminEventEditor />} />
        <Route path="events/:slug/dashboard" element={<AdminEventDashboard />} />
        <Route path="settings" element={<AdminSettings />} />
      </Route>
      <Route path="/:slug" element={<EventLayout />}>
        <Route index element={<EventOverview />} />
        <Route path=":module" element={<EventModulePage />} />
      </Route>
      <Route path="*" element={<NotFoundView />} />
    </Routes>
  );
}
